import { render, staticRenderFns } from "./SupplierFulfillmentColumn.vue?vue&type=template&id=53a435e6&scoped=true&"
import script from "./SupplierFulfillmentColumn.vue?vue&type=script&lang=js&"
export * from "./SupplierFulfillmentColumn.vue?vue&type=script&lang=js&"
import style0 from "./SupplierFulfillmentColumn.vue?vue&type=style&index=0&id=53a435e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a435e6",
  null
  
)

export default component.exports